import Results from "@/pages/Results";

// Public shared result page - renders Results with isSharedView=true
// Route: /share/:id (same param as Results)
export default function SharedResult() {
  return <Results isSharedView={true} />;
}
